<template>
  <el-row>
    <el-form :model="distributionClueMaintenanceEmployeeForm"
             ref="distributionClueMaintenanceEmployeeRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             addAction=""
             editAction="/businessIntranet/distributionClueMaintenanceEmployee.action"
             selectAction="/businessIntranet/selectClueMaintenanceEmployee.action"
             label-width="150px"
             style="width:50%"
             v-form>

        <el-form-item label="维护人：">
          <employee-select  ref="employee-select" v-model="distributionClueMaintenanceEmployeeForm.maintenanceEmployeeSnapId" @clear="clear" @onEmployeeSelected="onEmployeeSelectedQuery"
                           placeholder="请选择维护人"></employee-select>
        </el-form-item>

        <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import EmployeeSelect from '@/components/EmployeeSelect'

export default {
  name: 'distributionClueMaintenanceEmployee',
  extends: BasicPager,
  components: { EmployeeSelect },
  data: function () {
    return {
      rules: {},
      distributionClueMaintenanceEmployeeForm: {
        id: null,
        maintenanceEmployeeSnapId: null,
        maintenanceName: null

      }
    }
  },
  created () {
    this.distributionClueMaintenanceEmployeeForm.id = this.$route.query.clueCarId
  },
  methods: {
    clear: function () {
      this.distributionClueMaintenanceEmployeeForm.maintenanceEmployeeSnapId = null
      this.distributionClueMaintenanceEmployeeForm.maintenanceName = null
    },
    onEmployeeSelectedQuery: function (item) {
      this.distributionClueMaintenanceEmployeeForm.maintenanceEmployeeSnapId = item.snapshotId
      this.distributionClueMaintenanceEmployeeForm.maintenanceName = item.text
    },
    onFilterParams: function (params) {

    },
    onSelectInfo: function (dataInfo) {
      let employeeSelect = this.$refs['employee-select']
      if (dataInfo && dataInfo.datas) {
        employeeSelect.setValue(dataInfo.datas.maintenanceEmployeeId)
      }
    }
  },
  filters: {}

}
</script>

<style scoped>

</style>
